<hr>
<h2>Add Product</h2>
<button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div >
        <form name="form" [formGroup]="myForm" (ngSubmit)="addProduct()" novalidate>
        <div class="form-group" >
                <label for="productcode">Product Code</label>
                @if (myForm.get('productcode')?.invalid) 
                {
                @if (productcode?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Product Code has too many characters.
                    </div>
                }
                }            
                <input type="text" class="form-control" id="productcode" formControlName="productcode"  />
                
        </div>
        <div class="form-group" >
            <label for="description">Description</label>
            @if (myForm.get('description')?.invalid) 
            {
                @if (description?.errors?.['required']) {
                        <div class="help-block">
                            Description is required.
                        </div>
                }
                @if (description?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Description has too many characters.
                    </div>
                }
            }            
            <input type="text" class="form-control" id="description" formControlName="description" required />
        </div>
        <div class="form-group" >
                <label for="description2">Description 2</label>
                                      @if (myForm.get('description2')?.invalid) 
            {
                @if (description2?.errors?.['required']) {
                        <div class="help-block">
                            Description 2 is required.
                        </div>
                }
                @if (description2?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Description 2 has too many characters.
                    </div>
                }
            }            
                <input type="text" class="form-control" id="description2" formControlName="description2" required />
        </div>
 
        
        <div class="form-group" >
                <label for="uom">Unit of Measure</label>
                @if (myForm.get('uom')?.invalid) 
                {
                @if (uom?.errors?.['maxlength']) 
                {
                    <div class="help-block">
                            Unit of Measure has too many characters.
                    </div>
                }
                }            
                <input type="text" class="form-control" id="uom" formControlName="uom"  />
                
        </div>


        <div class="form-group">
            <button type="submit" [disabled]="myForm.invalid" class="btn btn-primary">Add</button>
        </div>
    </form>
</div>